import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckDouble, faEnvelopeCircleCheck, faLock, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import './login.css'
import { useAuthServices } from '../../services/useFetch'
import logoAgendate from '../../img/logoAgendate4.png'

export const RegistraAgendaTe = ({ setSelectActionPublicZone }) => {

  const { requestPost } = useAuthServices();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [])

  const tiposDeNegocio = [
    { value: 'INITIAL', label: 'Seleccione' },
    { value: 'NEGOCIO_1', label: 'Salud, bienestar y cuidado personal' },
    { value: 'NEGOCIO_2', label: 'Belleza, peluquería y cuidado estético' },
    { value: 'NEGOCIO_3', label: 'Clínicas y servicios veterinarios' }
  ]

  const tiposDeGestion = [
    { value: 'INITIAL', label: 'Seleccione' },
    { value: 'GESTION_1', label: 'Soy un profesional que gestionará solo mi propia agenda.' },
    { value: 'GESTION_2', label: 'Represento a una institución y gestionaré varias agendas para distintos profesionales' }
  ]

  const [formTipoGestion, setFormTipoGestion] = useState('')
  const [showMsgErrorEmail, setShowMsgErrorPassEmail] = useState(false)

  const [modalInfo, setModalInfo] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [modalError000, setModalError000] = useState(false)
  const [modalError001, setModalError001] = useState(false)
  const [modalError002, setModalError002] = useState(false)

  const [formStateValue, setformStateValue] = useState({
    tipoNegocio: 'INITIAL',
    tipoGestion: 'INITIAL',
    nombreInstitucion: '',
    idInstitucion: '',
    nombres: '',
    apellidos: '',
    identificacion: '',
    correo: '',
    correoConfirma: '',
    telefono: '',
  })

  const [formState, setformState] = useState({
    tipoNegocioRef: false,
    tipoGestionRef: false,
    nombreInstitucionRef: false,
    idInstitucionRef: false,
    nombresRef: false,
    apellidosRef: false,
    identificacionRef: false,
    correoRef: false,
    correoConfirmaRef: false,
    telefonoRef: false,
  })

  const {
    tipoNegocio,
    tipoGestion,
    nombreInstitucion,
    idInstitucion,
    nombres,
    apellidos,
    identificacion,
    correo,
    correoConfirma,
    telefono } = formStateValue;

  const {
    tipoNegocioRef,
    tipoGestionRef,
    nombreInstitucionRef,
    idInstitucionRef,
    nombresRef,
    apellidosRef,
    identificacionRef,
    correoRef,
    correoConfirmaRef,
    telefonoRef } = formState;

  const actionVolver = () => {
    setSelectActionPublicZone('LANDING_AGENDATE')
  }

  const changeInput = (e) => {
    setformStateValue({
      ...formStateValue,
      [e.target.name]: e.target.value
    })
  }

  const registraCompanyAction = () => {
    let formValidado = [];
    setformState({
      tipoNegocioRef: false,
      tipoGestionRef: false,
      nombreInstitucionRef: false,
      idInstitucionRef: false,
      nombresRef: false,
      apellidosRef: false,
      identificacionRef: false,
      correoRef: false,
      correoConfirmaRef: false,
      telefonoRef: false,
    })
    setShowMsgErrorPassEmail(false)

    if (!!tipoNegocio && tipoNegocio === 'INITIAL') {
      formValidado.push('tipoNegocioRef');
    }

    if (!!tipoGestion && tipoGestion === 'INITIAL') {
      formValidado.push('tipoGestionRef');
    } else {
      if (tipoGestion === 'GESTION_2') {
        if (!nombreInstitucion && nombreInstitucion.length === 0) {
          formValidado.push('nombreInstitucionRef');
        }
        if (!idInstitucion && idInstitucion.length === 0) {
          formValidado.push('idInstitucionRef');
        }
      }
    }

    if (!nombres && nombres.length === 0) {
      formValidado.push('nombresRef');
    }

    if (!apellidos && apellidos.length === 0) {
      formValidado.push('apellidosRef');
    }

    if (!identificacion && identificacion.length === 0) {
      formValidado.push('identificacionRef');
    }

    if (!correo && correo.length === 0) {
      formValidado.push('correoRef');
      if (!correoConfirma && correoConfirma.length === 0) {
        formValidado.push('correoConfirmaRef');
      }
    } else {
      if (!correoConfirma && correoConfirma.length === 0) {
        formValidado.push('correoConfirmaRef');
      } else {
        if (correo !== correoConfirma) {
          formValidado.push('correoRef');
          formValidado.push('correoConfirmaRef');
        } else {
          const regex = /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/;
          if (!regex.test(correo)) {
            formValidado.push('correoRef');
            formValidado.push('correoConfirmaRef');
            setShowMsgErrorPassEmail(true)
          }
        }
      }
    }

    if (!telefono && telefono.length === 0) {
      formValidado.push('telefonoRef');
    }

    if (formValidado.length === 0) {
      registraCompanyService()
    } else {
      setformState({
        tipoNegocioRef: formValidado.includes('tipoNegocioRef'),
        tipoGestionRef: formValidado.includes('tipoGestionRef'),
        nombreInstitucionRef: formValidado.includes('nombreInstitucionRef'),
        idInstitucionRef: formValidado.includes('idInstitucionRef'),
        nombresRef: formValidado.includes('nombresRef'),
        apellidosRef: formValidado.includes('apellidosRef'),
        identificacionRef: formValidado.includes('identificacionRef'),
        correoRef: formValidado.includes('correoRef'),
        correoConfirmaRef: formValidado.includes('correoConfirmaRef'),
        telefonoRef: formValidado.includes('nombresRef'),
      })
      formValidado.splice(0, formValidado.length)
    }
  }

  const registraCompanyService = async () => {
    const body = {
      tipoNegocio,
      tipoGestion,
      nombreInstitucion,
      idInstitucion,
      nombres,
      apellidos,
      identificacion,
      correo,
      telefono
    }
    const response = await requestPost(body, 3);
    if (!response.error) {
      const { estado, mensaje } = response.data
      if (estado) {
        setTimeout(() => {
          resetForm()
          handleShowInfo()
        }, 1000)
      } else {
        if (mensaje === 'AT_BCK_001') {
          resetForm()
          setModalError001(true)
        } else if (mensaje === 'AT_BCK_002') {
          setModalError002(true)
        } else {
          setModalError000(true)
        }
      }
    } else {
      setModalError(true)
    }
  };

  const resetForm = () => {
    setformStateValue({
      tipoNegocio: 'INITIAL',
      tipoGestion: 'INITIAL',
      nombreInstitucion: '',
      idInstitucion: '',
      nombres: '',
      apellidos: '',
      identificacion: '',
      correo: '',
      correoConfirma: '',
      telefono: '',
    })
  };

  const handleShowInfo = () => {
    setModalInfo(true)
  };

  const handleCloseInfo = () => {
    setModalInfo(false)
    actionVolver()
  };

  const handleCloseError = () => {
    setModalError(false)
  };

  const handleCloseModalError000 = () => {
    setModalError000(false)
  };

  const handleCloseModalError001 = () => {
    setModalError001(false)
    actionVolver()
  };

  const handleCloseModalError002 = () => {
    setModalError002(false)
  };

  const handleSelectTipoAgenda = (e) => {
    setformState({
      tipoNegocioRef: false,
      tipoGestionRef: false,
      nombreInstitucionRef: false,
      idInstitucionRef: false,
      nombresRef: false,
      apellidosRef: false,
      identificacionRef: false,
      correoRef: false,
      correoConfirmaRef: false,
      telefonoRef: false,
    })

    const tipoGestionAgenda = e.target.value
    setformStateValue({
      ...formStateValue,
      tipoGestion: tipoGestionAgenda,
      nombreInstitucion: '',
      idInstitucion: '',
      nombres: '',
      apellidos: '',
      identificacion: '',
      correo: '',
      correoConfirma: '',
      telefono: '',
    })
    switch (tipoGestionAgenda) {
      case 'GESTION_1':
        setFormTipoGestion('FORM_GESTION_1')
        break
      case 'GESTION_2':
        setFormTipoGestion('FORM_GESTION_2')
        break
      default:
        setFormTipoGestion('')
        break
    }
  };

  const viewFormTypeGestion = () => {
    switch (formTipoGestion) {
      case 'FORM_GESTION_1':
        return (
          <>
            <hr />
            <p className='p-label-form'> Nombres: </p>
            <input type="text" name='nombres' className={nombresRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={nombres} onChange={changeInput} />

            <p className='p-label-form'> Apellidos: </p>
            <input type="text" name='apellidos' className={apellidosRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={apellidos} onChange={changeInput} />

            <p className='p-label-form'> No identificación: </p>
            <input type="text" name='identificacion' className={identificacionRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={identificacion} onChange={changeInput} />

            <p className='p-label-form'> Correo electrónico: </p>
            <input type="text" name='correo' className={correoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={correo} onChange={changeInput} />

            <p className='p-label-form'> Confirmar correo electrónico: </p>
            <input type="text" name='correoConfirma' className={correoConfirmaRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={correoConfirma} onChange={changeInput} />

            <p className='p-label-form'> Número celular: </p>
            <input type="text" name='telefono' className={telefonoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={telefono} onChange={changeInput} />
          </>
        )
      case 'FORM_GESTION_2':
        return (
          <>
            <hr />
            <p className='p-label-form'>Nombre del centro o institución:</p>
            <input type="text" name='nombreInstitucion' className={nombreInstitucionRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={nombreInstitucion} onChange={changeInput} />

            <p className='p-label-form'>NIT:</p>
            <input type="text" name='idInstitucion' className={idInstitucionRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={idInstitucion} onChange={changeInput} />

            <p className='p-label-form'> Nombres representante legal: </p>
            <input type="text" name='nombres' className={nombresRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={nombres} onChange={changeInput} />

            <p className='p-label-form'> Apellidos representante legal: </p>
            <input type="text" name='apellidos' className={apellidosRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={apellidos} onChange={changeInput} />

            <p className='p-label-form'> No identificación representante legal: </p>
            <input type="text" name='identificacion' className={identificacionRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={identificacion} onChange={changeInput} />

            <p className='p-label-form'> Correo electrónico: </p>
            <input type="text" name='correo' className={correoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={correo} onChange={changeInput} />

            <p className='p-label-form'> Confirmar correo electrónico: </p>
            <input type="text" name='correoConfirma' className={correoConfirmaRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={correoConfirma} onChange={changeInput} />

            <p className='p-label-form'> Número celular: </p>
            <input type="text" name='telefono' className={telefonoRef ? 'form-control form-control-error' : 'form-control'} placeholder='' autoComplete='off'
              value={telefono} onChange={changeInput} />
          </>
        )
      default:
        return (
          <></>
        )
    }
  }

  return (
    <>
      <div className='div-container'>
        <div className="row m-0">
          <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
          <div className="col-12 col-sm-12 col-md-10 col-lg-6 p-0">
            <div className='div-registra'>
              <div className='div-registra-elements'>
                <div className='div-elements-children' >
                  <div className='div-titulo-registra-logo'>
                    <img src={logoAgendate} alt='logoAgendate' className='img-logo-agendate-login'
                      onClick={() => setSelectActionPublicZone('LANDING_AGENDATE')}>
                    </img>
                  </div>
                  <br />
                  <h3 className='titulo-login-1'>Aquí comienza la evolución que tu negocio merece.</h3>
                  <p >Contarás con un período gratuito de 30 días a partir de la activación de tu cuenta.</p>
                  <br />
                  <div>
                    <p className='p-label-form'>¿Qué tipo de negocio tienes?:</p>
                    <select name='tipoNegocio' value={tipoNegocio} onChange={changeInput} className={tipoNegocioRef ? 'form-control form-control-error' : 'form-control'} >
                      {
                        tiposDeNegocio.map((key, i) => {
                          return (
                            <option key={i} value={key.value}>{key.label}</option>
                          )
                        })
                      }
                    </select>
                    <br />
                    <p className='p-label-form'>¿Cómo vas a gestionar tu agenda?:</p>
                    <select name='tipoGestion' value={tipoGestion} onChange={handleSelectTipoAgenda} className={tipoGestionRef ? 'form-control form-control-error' : 'form-control'} >
                      {
                        tiposDeGestion.map((key, i) => {
                          return (
                            <option key={i} value={key.value}>{key.label}</option>
                          )
                        })
                      }
                    </select>
                    {
                      viewFormTypeGestion()
                    }
                    <div className='div-terminos-condiciones-padre'>
                      <div className='div-terminos-condiciones'>
                        <input name="isGoing" type="checkbox" />
                        <p className='p-terminos-condiciones'>Acepta los términos y condiciones.</p>
                      </div>
                      {
                        showMsgErrorEmail ?
                          <p className='frt-message-error'>**El correo ingresado no está en un formato válido.</p>
                          :
                          <></>
                      }
                    </div>
                  </div>
                  <div className='div-bottom-custom-registra'>
                    <button onClick={registraCompanyAction} className='bottom-custom'>
                      Crear cuenta
                    </button>
                  </div>
                </div>
              </div>
              <p className='p-info-login'>Agenda-te | Todos los derechos reservados </p>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-1 col-lg-3 p-0" ></div>
        </div>
      </div>
      <Modal isOpen={modalInfo} onHide={handleCloseInfo} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Excelente, ahora eres parte de AgendaTe!!! <FontAwesomeIcon icon={faCheckDouble} className='icon-check' /></h4>
        </ModalHeader>
        <ModalBody>
          <p>Tu cuenta ha sido creada exitosamente.</p>
          <br />
          <h5>¿Qué sigue? <FontAwesomeIcon icon={faEnvelopeCircleCheck} className='px-2' /></h5>
          <p className='mt-2'>En breve recibirás un correo electrónico con las instrucciones para activar tu cuenta y comenzar a usar nuestros servicios.</p>
          <br />
          <h5>Seguridad ante todo <FontAwesomeIcon icon={faLock} className='px-2' /></h5>
          <p className='mt-2'>Si no ves el correo en tu bandeja de entrada, revisa tu carpeta de spam o correo no deseado.
            El mensaje contiene información importante para tu primer ingreso.</p>
          <br />
          <h5>¡Gracias por unirte a AgendaTe!</h5>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseInfo}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalError} onHide={handleCloseError} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Error de comunicación <FontAwesomeIcon icon={faExclamationTriangle} className='icon-error' /> </h4>
        </ModalHeader>
        <ModalBody>
          <p>Vaya, tenemos algunas dificultades de comunicación en este momento, por favor intenta mas tarde.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseError}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalError000} onHide={handleCloseModalError000} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>No pudimos completar tu solicitud<FontAwesomeIcon icon={faExclamationTriangle} className='icon-error mx-3' /> </h4>
        </ModalHeader>
        <ModalBody>
          <p>Hubo un inconveniente al procesar la información. Por favor, inténtalo nuevamente en unos instantes o verifica tu conexión.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseModalError000}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modalError001} onHide={handleCloseModalError001} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Usuario ya registrado <FontAwesomeIcon icon={faExclamationTriangle} className='icon-warning' /> </h4>
        </ModalHeader>
        <ModalBody>
          <p>Parece que ya te has registrado anteriormente. Intenta iniciar sesión o recupera tu contraseña.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseModalError001}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalError002} onHide={handleCloseModalError002} className='modal-perfil-cliente'>
        <ModalHeader closeButton>
          <h4>Correo en formato incorrecto <FontAwesomeIcon icon={faExclamationTriangle} className='icon-warning' /> </h4>
        </ModalHeader>
        <ModalBody>
          <p>El correo electrónico debe tener un formato válido. Por favor, verifica que el correo electrónico tenga un formato correcto.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={handleCloseModalError002}>
            Aceptar
          </Button>
        </ModalFooter>
      </Modal>
    </>

  )
}
